<!-- this file should turn semi-colon in prettierrc.js to true -->
<template>
  <div v-if="!isLoadingPage">
    <div v-if="permission !== null">
      <div v-if="permission.read_perm == 1">
        <v-card
          elevation="0"
          style="
            border-bottom: 2px solid rgba(0, 0, 0, 0.1);
            margin-bottom: 20px;
            display: flex;
            justify-content: space-between;
            position: sticky;
            top: 60px;
            background: white;
            z-index: 5;
          "
        >
          <v-card-title>
            <p
              class="text-h6 font-weight-bold text-center text-uppercase"
              style="margin: auto"
            >
              Detail Safety Performance Report
              <v-tooltip bottom color="grey">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    x-small
                    text
                    icon
                    color="grey darken-2"
                    @click="getDataFromApi"
                    style="position: relative; top: -3px"
                  >
                    <v-icon small>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>refresh page</span>
              </v-tooltip>
            </p>
            <p
              v-if="detailData"
              style="
                position: absolute;
                bottom: -20px;
                left: 13px;
                font-weight: bold;
                padding-left: 3px;
                font-size: 14px;
              "
            >
              {{ detailData.audit_no }}
            </p>
          </v-card-title>
          <div class="actionButton">
            <v-btn
              type="button"
              rounded
              elevation="0"
              class="font-weight-bold ma-2"
              @click.prevent="closeDetailReport"
              outlined
              x-small
            >
              <v-icon x-small>mdi-chevron-left</v-icon>
              Kembali
            </v-btn>
            <div
              style="
                position: absolute;
                bottom: 2px;
                right: 0;
                border: 1px solid black;
              "
            >
              <p
                v-if="detailData"
                :style="`background-color: ${statusColor(detailData.status)};
                color: white;
                font-weight: bold;
                width: 180px;
                text-align: center;
                margin:0`"
              >
                {{ detailData.status.name }}
              </p>
            </div>
          </div>
        </v-card>
        <v-card elevation="0" v-if="detailData != null">
          <v-card-text>
            <p
              style="
                position: absolute;
                top: -20px;
                left: 10px;
                font-weight: bold;
                padding-left: 4px;
                font-size: 12px;
              "
            >
              Tgl. Buat: {{ detailData.created_at }} |
              {{ detailData.created_by_name }}
            </p>
            <v-form
              ref="entryForm"
              :readonly="!isEdit"
              @submit.prevent="saveForm"
              style="margin-top: 10px"
            >
              <div>
                <v-row>
                  <v-col
                    v-if="!isEdit"
                    cols="12"
                    md="3"
                    class="d-flex flex-column"
                  >
                    <p
                      class="text-left"
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      No. Dokumen
                    </p>
                    <v-text-field
                      v-model="detailData.document_no"
                      dense
                      readonly
                      style="height: 45px"
                    />
                  </v-col>
                  <v-col v-else cols="12" md="3" class="d-flex flex-column">
                    <p
                      class="text-left"
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Nama Dokumen
                    </p>
                    <v-text-field
                      v-model="detailData.name"
                      dense
                      outlined
                      style="height: 45px"
                    />
                  </v-col>
                  <v-col cols="12" md="3" class="d-flex flex-column">
                    <p
                      class="text-left"
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Perusahaan
                    </p>
                    <v-text-field
                      v-if="!isEdit"
                      v-model="detailData.company_name"
                      dense
                      :outlined="isEdit"
                      :clearable="isEdit"
                      style="height: 45px"
                    />
                    <v-autocomplete
                      v-else
                      v-model="detailData.company"
                      :items="dropdown.company"
                      :rules="rules.companyRules"
                      :outlined="isEdit"
                      :clearable="isEdit"
                      item-text="name"
                      item-value="id"
                      return-object
                      dense
                      style="height: 45px"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="3" class="d-flex flex-column">
                    <p
                      class="text-left"
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      PIC
                    </p>
                    <v-text-field
                      v-if="!isEdit"
                      v-model="detailData.pic_name"
                      dense
                      :outlined="isEdit"
                      :clearable="isEdit"
                      style="height: 45px"
                    />
                    <v-autocomplete
                      v-else
                      v-model="detailData.pic"
                      :items="dropdown.employee"
                      :search-input.sync="searchEmployee"
                      :outlined="isEdit"
                      :clearable="isEdit"
                      @change="watcherEmployee"
                      item-text="name"
                      item-value="id"
                      return-object
                      dense
                      style="height: 45px"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="2" class="d-flex flex-column">
                    <p
                      class="text-left"
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Periode
                    </p>
                    <v-text-field
                      v-model="detailData.report_date"
                      dense
                      :outlined="isEdit"
                      :clearable="isEdit"
                      style="height: 45px"
                      type="month"
                      name="month"
                      step="1"
                    />
                  </v-col>
                  <v-col cols="8" class="d-flex flex-column">
                    <v-row>
                      <v-col cols="4" md="2" class="d-flex flex-column">
                        <p
                          class="text-left"
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Jml Karyawan
                        </p>
                        <v-text-field
                          v-model="detailData.total_employee"
                          :readonly="!isEdit"
                          dense
                          outlined
                          type="number"
                          style="height: 45px"
                        />
                      </v-col>
                      <v-col cols="4" md="2" class="d-flex flex-column">
                        <p
                          class="text-left"
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Orang Lain
                        </p>
                        <v-text-field
                          v-model="detailData.total_other_people"
                          :readonly="!isEdit"
                          dense
                          outlined
                          type="number"
                          style="height: 45px"
                        />
                      </v-col>
                      <v-col cols="4" md="2" class="d-flex flex-column">
                        <p
                          class="text-left"
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Hari Kerja
                        </p>
                        <v-text-field
                          v-model="detailData.workdays"
                          :readonly="!isEdit"
                          dense
                          outlined
                          type="number"
                          style="height: 45px"
                        />
                      </v-col>
                      <v-col
                        v-if="!isEdit"
                        cols="4"
                        md="2"
                        class="d-flex flex-column"
                      >
                        <p
                          class="text-left"
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          Manhour
                        </p>
                        <v-text-field
                          :value="setSparator(detailData.manhour)"
                          dense
                          outlined
                          readonly
                          style="height: 45px"
                        />
                      </v-col>
                    </v-row>
                    <v-row v-if="!isEdit">
                      <v-col cols="4" md="2" class="d-flex flex-column">
                        <p
                          class="text-left"
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          FAC
                        </p>
                        <v-text-field
                          dense
                          outlined
                          readonly
                          :value="
                            detailData.summary != null
                              ? detailData.summary.fac
                              : 0
                          "
                          style="height: 45px"
                        />
                      </v-col>
                      <v-col cols="4" md="2" class="d-flex flex-column">
                        <p
                          class="text-left"
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          MTC
                        </p>
                        <v-text-field
                          dense
                          outlined
                          readonly
                          :value="
                            detailData.summary != null
                              ? detailData.summary.mtc
                              : 0
                          "
                          style="height: 45px"
                        />
                      </v-col>
                      <v-col cols="4" md="2" class="d-flex flex-column">
                        <p
                          class="text-left"
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                          "
                        >
                          LTI
                        </p>
                        <v-text-field
                          dense
                          outlined
                          readonly
                          :value="
                            detailData.summary != null
                              ? detailData.summary.lti
                              : 0
                          "
                          style="height: 45px"
                        />
                      </v-col>
                      <v-col
                        cols="4"
                        md="2"
                        class="d-flex flex-column overflow-hidden"
                      >
                        <p
                          class="text-left"
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                            white-space: nowrap;
                          "
                        >
                          Manday Loss
                        </p>
                        <v-text-field
                          dense
                          outlined
                          readonly
                          :value="
                            detailData.summary != null
                              ? detailData.summary.mandayLoss
                              : 0
                          "
                          style="height: 45px"
                        />
                      </v-col>
                      <v-col
                        cols="4"
                        md="2"
                        class="d-flex flex-column overflow-hidden"
                      >
                        <p
                          class="text-left"
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                            white-space: nowrap;
                          "
                        >
                          Property Damage
                        </p>
                        <v-text-field
                          dense
                          outlined
                          readonly
                          :value="
                            detailData.summary != null
                              ? detailData.summary.propertyDmg
                              : 0
                          "
                          style="height: 45px"
                        />
                      </v-col>
                      <v-col
                        cols="4"
                        md="2"
                        class="d-flex flex-column overflow-hidden"
                      >
                        <p
                          class="text-left"
                          style="
                            margin: 0;
                            font-size: 12px;
                            font-weight: bold;
                            color: rgba(0, 0, 0, 0.5);
                            white-space: nowrap;
                          "
                        >
                          Fatal Incident
                        </p>
                        <v-text-field
                          dense
                          outlined
                          readonly
                          :value="
                            detailData.summary != null
                              ? detailData.summary.fatal
                              : 0
                          "
                          style="height: 45px"
                        />
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col v-if="!isEdit" cols="4" class="d-flex flex-column">
                    <v-row align="end">
                      <v-col cols="6" class="d-flex flex-column py-4">
                        <v-sheet
                          rounded="xl"
                          class="pa-4 text-center d-flex flex-column justify-content-around align-center"
                          :color="getRateColor()"
                          style="height: 130px"
                        >
                          <!-- style="height: 130px; color: #f5f5f5" <--red -->
                          <!-- style="height: 130px; color: #88f587" <--green -->
                          <div class="text-h6 font-weight-bold">
                            Frequency Rate
                          </div>
                          <div class="display-2">{{ frequencyRate }}</div>
                        </v-sheet>
                      </v-col>
                      <v-col cols="6" class="d-flex flex-column py-4">
                        <v-sheet
                          rounded="xl"
                          class="pa-4 text-center d-flex flex-column justify-content-around align-center"
                          :color="getRateColor()"
                          style="height: 130px"
                        >
                          <div class="text-h6 font-weight-bold">
                            Severity Rate
                          </div>
                          <div class="display-2">{{ severityRate }}</div>
                        </v-sheet>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    v-if="detailData.status.id == 3"
                    cols="8"
                    class="d-flex flex-column"
                  >
                    <p
                      class="text-left"
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Alasan Cancel
                    </p>
                    <v-text-field
                      v-model="detailData.cancel_note"
                      rows="1"
                      :auto-grow="true"
                    />
                  </v-col>
                </v-row>
              </div>
              <v-card-actions
                v-if="
                  getUserProfile.level.find(
                    ({ id }) =>
                      id == appLevel.adminK3 ||
                      id == appLevel.picK3 ||
                      id == appLevel.viewer ||
                      id == appLevel.administrator
                  ) != undefined
                "
              >
                <div
                  v-if="!isEdit"
                  style="
                    position: absolute;
                    top: -15px;
                    right: 0px;
                    padding-left: 2px;
                  "
                >
                  <div
                    v-if="
                      getUserProfile.level.find(
                        ({ id }) =>
                          id == appLevel.adminK3 ||
                          id == appLevel.picK3 ||
                          id == appLevel.administrator
                      ) != undefined && detailData.status.id == 0
                    "
                  >
                    <v-btn
                      style="font-weight: bold"
                      x-small
                      text
                      outlined
                      color="primary"
                      @click.prevent="enableEdit"
                    >
                      <v-icon
                        x-small
                        color="primary"
                        style="position: relative; top: 1px"
                      >
                        mdi-pencil
                      </v-icon>
                      Edit Header
                    </v-btn>
                    <v-btn
                      style="font-weight: bold; margin-left: 5px"
                      x-small
                      text
                      outlined
                      color="success"
                      @click="submitReportDocument"
                    >
                      SUBMIT
                    </v-btn>
                    <v-btn
                      style="font-weight: bold; margin-left: 5px"
                      x-small
                      text
                      outlined
                      color="red"
                      @click="cancelReportDocument"
                    >
                      CANCEL
                    </v-btn>
                  </div>
                  <div
                    v-if="
                      getUserProfile.level.find(
                        ({ id }) =>
                          id == appLevel.adminK3 ||
                          id == appLevel.viewer ||
                          id == appLevel.administrator
                      ) != undefined && detailData.status.id == 1
                    "
                  >
                    <div v-if="isAllowApprove">
                      <v-btn
                        style="font-weight: bold; margin-left: 5px"
                        x-small
                        text
                        outlined
                        color="success"
                        @click="confirmReportDocument"
                      >
                        CONFIRM
                      </v-btn>
                      <v-btn
                        style="font-weight: bold; margin-left: 5px"
                        x-small
                        text
                        outlined
                        color="red"
                        @click="rejectReportDocument"
                      >
                        REJECT
                      </v-btn>
                    </div>
                  </div>
                  <div
                    v-if="
                      getUserProfile.level.find(
                        ({ id }) =>
                          id == appLevel.adminK3 ||
                          id == appLevel.picK3 ||
                          id == appLevel.administrator
                      ) != undefined &&
                      (detailData.status.id == 3 || detailData.status.id == 4)
                    "
                  >
                    <v-btn
                      style="font-weight: bold; margin-left: 5px"
                      x-small
                      text
                      outlined
                      color="primary"
                      @click="setDraftReport"
                    >
                      SET DRAFT
                    </v-btn>
                  </div>
                </div>

                <div v-else style="position: absolute; top: -15px; right: 10px">
                  <v-btn
                    style="font-weight: bold"
                    x-small
                    text
                    outlined
                    color="primary"
                    type="submit"
                  >
                    <v-icon
                      x-small
                      color="primary"
                      style="position: relative; top: 1px"
                    >
                      mdi-content-save-edit-outline
                    </v-icon>
                    Save
                  </v-btn>
                  <v-btn
                    style="font-weight: bold; margin-left: 10px"
                    x-small
                    text
                    outlined
                    color="red"
                    @click="enableEdit"
                  >
                    <v-icon
                      x-small
                      color="red"
                      style="position: relative; top: 1px"
                    >
                      mdi-cancel
                    </v-icon>
                    Cancel
                  </v-btn>
                </div>
              </v-card-actions>
            </v-form>
          </v-card-text>
          <v-card-text v-if="!isEdit">
            <v-card v-if="!loading">
              <v-tabs
                v-model="tab"
                background-color="#ccdbdc"
                slider-color="primary"
              >
                <v-tab v-for="item in tabItems" :key="item.tab">
                  {{ item.tab }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item
                  v-for="item in tabItems"
                  :key="item.tab"
                  style="padding: 10px"
                >
                  <div style="min-height: 70vh; padding: 0">
                    <div
                      v-if="item.tab == 'Laporan Insiden'"
                      style="padding-top: 10px"
                    >
                      <div class="position-relative z-0">
                        <v-btn
                          v-if="
                            !isEdit &&
                            detailData.status.id == 0 &&
                            getUserProfile.level.find(
                              ({ id }) =>
                                id == appLevel.adminK3 ||
                                id == appLevel.picK3 ||
                                id == appLevel.administrator
                            ) != undefined
                          "
                          color="blue darken-1"
                          type="button"
                          small
                          outlined
                          class="white--text"
                          @click="addNewIncidentReport"
                        >
                          Tambah Laporan
                        </v-btn>
                      </div>
                      <v-card elevation="3" class="mt-5">
                        <v-data-table
                          mobile-breakpoint="0"
                          fixed-header
                          height="50vh"
                          :headers="incidentReportHeader"
                          style="cursor: pointer"
                          :items="incidentReportData"
                          :loading="loading"
                          @click:row="incidentReportRowClick"
                          :items-per-page="10"
                        >
                          <!-- <template v-slot:[`item.name`]="{ item }">
                            <div
                              style="
                                width: 120px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.name }}
                            </div>
                          </template> -->
                          <template v-slot:[`item.document_no`]="{ item }">
                            <div
                              style="
                                width: 120px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.document_no }}
                            </div>
                          </template>
                          <template v-slot:[`item.company_name`]="{ item }">
                            <div
                              style="
                                width: 120px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.company_name }}
                            </div>
                          </template>
                          <template v-slot:[`item.classification`]="{ item }">
                            <div
                              style="
                                width: 80px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{
                                item.inspection_report != null
                                  ? item.inspection_report
                                      .accident_classification != null
                                    ? item.inspection_report
                                        .accident_classification.name
                                    : '-'
                                  : '-'
                              }}
                            </div>
                          </template>
                          <template
                            v-slot:[`item.incident_location_name`]="{ item }"
                          >
                            <div
                              style="
                                width: 80px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.incident_location_name }}
                            </div>
                          </template>
                          <template v-slot:[`item.incident_date`]="{ item }">
                            <div
                              style="
                                width: 120px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{
                                convertDate(item.incident_date).slice(
                                  0,
                                  convertDate(item.incident_date).lastIndexOf(
                                    ','
                                  )
                                ) +
                                ' ' +
                                item.incident_time
                              }}
                            </div>
                          </template>
                          <template v-slot:[`item.reported_date`]="{ item }">
                            <div
                              style="
                                width: 80px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{
                                convertDate(item.reported_date).slice(
                                  0,
                                  convertDate(item.incident_date).lastIndexOf(
                                    ','
                                  )
                                )
                              }}
                            </div>
                          </template>
                          <!-- <template v-slot:[`item.createdAt`]="{ item }">
                            <div
                              style="
                                width: 80px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ convertDate(item.createdAt) }}
                            </div>
                          </template>
                          <template v-slot:[`item.updatedAt`]="{ item }">
                            <div
                              style="
                                width: 80px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ convertDate(item.updatedAt) }}
                            </div>
                          </template> -->
                          <template v-slot:[`item.status`]="{ item }">
                            <div
                              :style="`
                                      color: ${itemStatusColor(
                                        item.status
                                      )}; font-weight: bold;
                                        font-size: 12px;
                                        padding: 0;
                                        display: flex;
                                        flex-direction: row;`"
                            >
                              {{ itemStatusName(item.status) }}
                            </div>
                          </template>
                          <template
                            v-slot:[`item.inspection_report`]="{ item }"
                          >
                            <div
                              @click.stop
                              style="
                                width: 0px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: column;
                                align-items: center;
                                justify-content: center;
                              "
                            >
                              <v-checkbox
                                v-model="item.is_inspection_complete"
                                readonly
                                :color="
                                  item.inspection_report != null &&
                                  item.inspection_report.status == 1
                                    ? 'green'
                                    : ''
                                "
                              ></v-checkbox>
                            </div>
                          </template>
                          <template
                            v-slot:[`item.root_problem_report`]="{ item }"
                          >
                            <div
                              @click.stop
                              style="
                                width: 0px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                justify-content: center;
                              "
                            >
                              <v-checkbox
                                v-model="item.is_rootcause_complete"
                                readonly
                                :color="
                                  item.root_problem_report != null &&
                                  item.root_problem_report.status == 5
                                    ? 'green'
                                    : ''
                                "
                              ></v-checkbox>
                            </div>
                          </template>
                        </v-data-table>
                      </v-card>
                    </div>
                    <div
                      v-if="item.tab == 'Laporan Leading'"
                      style="padding-top: 10px"
                    >
                      <div class="position-relative z-0">
                        <v-btn
                          v-if="
                            !isEdit &&
                            detailData.status.id == 0 &&
                            getUserProfile.level.find(
                              ({ id }) =>
                                id == appLevel.adminK3 ||
                                id == appLevel.picK3 ||
                                id == appLevel.administrator
                            ) != undefined
                          "
                          color="blue darken-1"
                          type="button"
                          small
                          outlined
                          class="white--text"
                          @click="addNewLeadingReport"
                        >
                          Tambah Laporan
                        </v-btn>
                      </div>
                      <v-card elevation="3" class="mt-5">
                        <v-data-table
                          mobile-breakpoint="0"
                          fixed-header
                          height="50vh"
                          :headers="leadingReportHeader"
                          style="cursor: pointer"
                          :items="leadingReportData"
                          :loading="loading"
                          @click:row="leadingReportRowClick"
                          :items-per-page="10"
                        >
                          <template v-slot:[`item.document_no`]="{ item }">
                            <div
                              style="
                                width: 120px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.document_no }}
                            </div>
                          </template>
                          <template v-slot:[`item.company_name`]="{ item }">
                            <div
                              style="
                                width: 210px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.company_name }}
                            </div>
                          </template>
                          <template v-slot:[`item.leading_date`]="{ item }">
                            <div
                              style="
                                width: 70px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.leading_date }}
                            </div>
                          </template>
                          <template v-slot:[`item.leading`]="{ item }">
                            <div
                              style="
                                min-width: 120px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{
                                item.leading != null ? item.leading.name : '-'
                              }}
                            </div>
                          </template>
                          <template v-slot:[`item.description`]="{ item }">
                            <div
                              style="
                                width: 210px;
                                font-size: 12px;
                                padding: 0;
                                display: flex;
                                flex-direction: row;
                              "
                            >
                              {{ item.description }}
                            </div>
                          </template>
                          <template v-slot:[`item.status`]="{ item }">
                            <div
                              :style="`
                                      color: ${itemStatusLeadingColor(
                                        item.status
                                      )}; font-weight: bold;
                                        font-size: 12px;
                                        padding: 0;
                                        display: flex;
                                        flex-direction: row;`"
                            >
                              {{ itemStatusLeadingName(item.status) }}
                            </div>
                          </template>
                        </v-data-table>
                      </v-card>
                    </div>
                    <div v-if="item.tab == 'Approval'">
                      <div v-if="detailData != null" style="margin-top: 5px">
                        <v-row no-gutters style="padding: 0">
                          <v-col md="12" style="padding: 0">
                            <v-data-table
                              mobile-breakpoint="0"
                              fixed-header
                              height="50vh"
                              :headers="approvalHeaders"
                              :items="
                                detailData.approval_matrix != null
                                  ? detailData.approval_matrix
                                  : []
                              "
                              :items-per-page="10"
                              class="elevation-1 mx-auto"
                              hide-default-footer
                            >
                              <template v-slot:[`item.document_no`]="{ item }">
                                <div style="width: 140px; font-size: 12px">
                                  {{ item.document_no }}
                                </div>
                              </template>
                              <template v-slot:[`item.table_name`]="{ item }">
                                <div style="width: 140px; font-size: 12px">
                                  {{ item.table_name }}
                                </div>
                              </template>
                              <template
                                v-slot:[`item.approver_user`]="{ item }"
                              >
                                <div style="cursor: pointer" v-if="item">
                                  <v-chip
                                    label
                                    outlined
                                    small
                                    style="
                                      margin-right: 5px;
                                      padding: 0 3px;
                                      cursor: pointer;
                                      border: 1px solid rgba(0, 0, 0, 0.5);
                                    "
                                    v-for="(item, index) in item.approver_user"
                                    :key="index"
                                  >
                                    {{
                                      item.user !== null ? item.user.name : '-'
                                    }}
                                  </v-chip>
                                </div>
                              </template>
                              <template v-slot:[`item.approved`]="{ item }">
                                <div
                                  v-for="(items, index) in item.approver_user"
                                  :key="index"
                                  style="width: 140px"
                                >
                                  <v-chip
                                    v-if="items.status === 1"
                                    label
                                    outlined
                                    small
                                    style="
                                      position: relative;
                                      margin-right: 5px;
                                      padding: 0 3px;
                                      cursor: pointer;
                                      border: 1px solid rgba(0, 0, 0, 0.5);
                                    "
                                  >
                                    {{
                                      item.user !== null ? items.user.name : '-'
                                    }}
                                    <v-tooltip bottom color="primary">
                                      <template
                                        v-slot:activator="{ attrs, on }"
                                      >
                                        <div
                                          v-if="items.note"
                                          v-bind="attrs"
                                          v-on="on"
                                          @click="openCommentDialog(items)"
                                          style="
                                            position: absolute;
                                            top: 0;
                                            right: 0;
                                            width: 20px;
                                            bottom: 0;
                                            background: white;
                                          "
                                        >
                                          <v-icon small color="info"
                                            >mdi-comment-alert</v-icon
                                          >
                                        </div>
                                      </template>
                                      <span>Klik untuk melihat catatan</span>
                                    </v-tooltip>
                                  </v-chip>
                                </div>
                              </template>
                              <template v-slot:[`item.rejected`]="{ item }">
                                <div
                                  v-for="(items, index) in item.approver_user"
                                  :key="index"
                                  style="width: 140px"
                                >
                                  <v-chip
                                    v-if="items.status === -1"
                                    label
                                    outlined
                                    small
                                    style="
                                      margin-right: 5px;
                                      padding: 0 3px;
                                      cursor: pointer;
                                    "
                                  >
                                    {{
                                      item.user !== null ? items.user.name : '-'
                                    }}
                                    <v-tooltip bottom>
                                      <template
                                        v-slot:activator="{ attrs, on }"
                                      >
                                        <div
                                          v-if="items.note"
                                          v-bind="attrs"
                                          v-on="on"
                                          @click="openCommentDialog(items)"
                                          style="
                                            position: absolute;
                                            top: 0;
                                            right: 0;
                                            width: 20px;
                                            bottom: 0;
                                            background: white;
                                          "
                                        >
                                          <v-icon small color="info"
                                            >mdi-comment-alert</v-icon
                                          >
                                        </div>
                                      </template>
                                      <span>Klik untuk melihat catatan</span>
                                    </v-tooltip>
                                  </v-chip>
                                </div>
                              </template>
                              <template v-slot:[`item.created_at`]="{ item }">
                                <div style="width: 140px; font-size: 12px">
                                  {{ item.created_at }}
                                </div>
                              </template>
                              <template v-slot:[`item.updated_at`]="{ item }">
                                <div
                                  v-for="(items, index) in item.approver_user"
                                  :key="index"
                                  style="width: 140px; font-size: 12px"
                                >
                                  <span v-if="items.status === 1">
                                    {{
                                      items.updated_at !== null
                                        ? items.updated_at
                                        : '-'
                                    }}
                                  </span>
                                  <br v-if="index > 0" />
                                </div>
                              </template>
                            </v-data-table>
                          </v-col>
                        </v-row>
                        <div
                          v-if="
                            getUserProfile.level.find(
                              ({ id }) =>
                                id == appLevel.adminK3 ||
                                id == appLevel.picK3 ||
                                id == appLevel.administrator
                            ) !== undefined
                          "
                        >
                          <div
                            style="text-align: left; padding-left: 5px"
                            v-if="detailData.status.id == 1"
                          >
                            <v-btn
                              color="grey"
                              tile
                              dark
                              small
                              dense
                              style="
                                font-size: 10px;
                                width: 100px;
                                margin-top: 10px;
                              "
                              :loading="loading"
                              @click="fetchMatrix"
                            >
                              <span>Fetch Matrix</span>
                            </v-btn>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
            <div
              v-else
              class="d-flex justify-center align-center"
              style="height: 150px"
            >
              <v-progress-circular
                :size="80"
                :width="5"
                color="blue"
                indeterminate
                >Loading...</v-progress-circular
              >
            </div>
          </v-card-text>
        </v-card>
        <v-card
          v-else
          class="mx-auto"
          width="100%"
          style="
            z-index: 3;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 12px;
            position: fixed;
            top: 0;
            height: 100%;
            left: 0;
            right: 0;
            background: rgba(255, 255, 255);
          "
        >
          DATA NOT FOUND
        </v-card>
        <!--DIALOG MODAL  -->
        <!-- <v-dialog
          v-if="correctivePlanDesc != null"
          v-model="correctivePlanDialog"
          width="500"
          persistent
        >
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Rencana Perbaikan
            </v-card-title>

            <v-card-text class="d-flex justify-center align-center">
              <v-col md="12" style="padding: 0; position: relative; top: 20px">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <v-textarea
                      v-model="correctivePlanDesc.corrective_plan_desc"
                      :auto-grow="true"
                      rows="3"
                      outlined
                      clear-icon="mdi-close-circle"
                      :readonly="detailData.status.id != 2"
                    ></v-textarea>
                  </v-col>
                </div>
              </v-col>
            </v-card-text>

            <v-divider></v-divider>

            <v-btn
              style="position: absolute; top: 10px; right: 10px"
              fab
              icon
              x-small
              outlined
              @click="closeCorrectivePlanDialog"
            >
              <v-icon size="30" color="red">mdi-close</v-icon>
            </v-btn>
            <v-card-actions
              v-if="
                detailData.status.id == 2 &&
                correctivePlanDesc.status == 1 &&
                isAuditee
              "
            >
              <v-btn
                color="primary"
                text
                outlined
                @click="updateCorrectivePlanDesc"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
        <!-- <v-dialog
          v-if="verificationNote != null"
          v-model="verificationNoteDialog"
          width="500"
          persistent
        >
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Catatan Verifikasi
            </v-card-title>

            <v-card-text class="d-flex justify-center align-center">
              <v-col md="12" style="padding: 0; position: relative; top: 20px">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <v-textarea
                      v-model="verificationNote.verification_note"
                      :auto-grow="true"
                      rows="3"
                      outlined
                      clear-icon="mdi-close-circle"
                      :readonly="detailData.status.id != 2"
                    ></v-textarea>
                  </v-col>
                </div>
              </v-col>
            </v-card-text>

            <v-divider></v-divider>

            <v-btn
              style="position: absolute; top: 10px; right: 10px"
              fab
              icon
              x-small
              outlined
              @click="closeVerificationNoteDialog"
            >
              <v-icon size="30" color="red">mdi-close</v-icon>
            </v-btn>
          </v-card>
        </v-dialog> -->

        <!-- <v-dialog
          v-if="detailData !== null"
          v-model="evidenceDialog"
          width="500"
          persistent
        >
          <v-card style="position: relative">
            <v-card-title class="text-h5 grey lighten-2">
              {{ evidenceTitleModal }} Evidence File
            </v-card-title>
            <v-card-text class="d-flex justify-center align-center">
              <v-col md="12" style="padding: 0; position: relative; top: 20px">
                <v-data-table
                  v-if="evidenceFile != null"
                  mobile-breakpoint="0"
                  fixed-header
                  height="300"
                  style="cursor: pointer"
                  :headers="evidenceHeaders"
                  :items="evidenceFile"
                  @click:row="readyToDownload"
                >
                  <template v-slot:[`item.subject`]="{ item }">
                    <div
                      style="
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{
                        item.subject !== null
                          ? item.subject !== ''
                            ? item.subject
                            : '-'
                          : '-'
                      }}
                    </div>
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <div
                      style="
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      <v-btn
                        v-if="isCanAccessItemUpload"
                        icon
                        x-small
                        @click.stop="
                          unlinkDokumen(
                            item.file.slice(item.file.lastIndexOf('/') + 1)
                          )
                        "
                        style="margin-right: 5px"
                      >
                        <v-icon color="red">mdi-delete</v-icon>
                      </v-btn>
                      <v-btn icon x-small @click.stop="readyToDownload(item)">
                        <v-icon color="green">mdi-download</v-icon>
                      </v-btn>
                    </div>
                  </template>
                </v-data-table>

                <v-btn
                  v-if="isCanAccessItemUpload"
                  elevation="0"
                  style="margin-right: auto; width: 100%"
                  :loading="loading"
                  color="primary"
                  @click="openUploadModal('upload')"
                >
                  <v-icon small style="margin-right: 5px">mdi-upload</v-icon>
                  <span :style="`font-weight: bold; color:white;`"
                    >Tambah File</span
                  >
                </v-btn>
              </v-col>
            </v-card-text>
            <v-divider></v-divider>

            <v-card-actions>
              <v-btn
                color="error"
                text
                outlined
                @click="closeEvidenceDialog"
                :loading="loading"
              >
                Close
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                v-if="isCanAccessItemUpload"
                color="error"
                text
                outlined
                :loading="loading"
                @click="deleteAllFile"
              >
                Delete all File
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->

        <!-- <v-dialog v-model="uploadDialog" width="500" persistent>
          <v-form
            :disabled="loading"
            lazy-validation
            ref="entryFormUpload"
            @submit.prevent="submitUploadDoc"
            style="position: relative"
          >
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                UPLOAD
              </v-card-title>

              <v-card-text class="d-flex justify-center align-center">
                <v-col
                  md="12"
                  style="padding: 0; position: relative; top: 20px"
                >
                  <div style="padding: 0 10px">
                    <v-col cols="12" style="padding: 0">
                      <p
                        style="
                          margin: 0;
                          font-size: 12px;
                          font-weight: bold;
                          color: rgba(0, 0, 0, 0.5);
                        "
                      >
                        Subject
                      </p>
                    </v-col>
                    <v-col cols="12" style="padding: 0">
                      <div>
                        <v-text-field
                          outlined
                          v-model="file_subject"
                          dense
                          :rules="rules.subjectRules"
                        ></v-text-field>
                      </div>
                      <div
                        style="
                          padding: 10px;
                          border: 2px dashed grey;
                          height: 70px;
                        "
                      >
                        <v-file-input
                          ref="uploadDoc"
                          placeholder="Pilih File"
                          dense
                          append-icon="mdi-paperclip"
                          prepend-icon=""
                          @change="uploadFile"
                          :rules="rules.docRules"
                        ></v-file-input>
                      </div>
                    </v-col>
                  </div>
                </v-col>
              </v-card-text>

              <v-divider></v-divider>

              <v-card-actions>
                <v-btn
                  id="closeFileUpload"
                  color="error"
                  text
                  outlined
                  type="reset"
                  @click="openUploadModal('close')"
                  :loading="loading"
                >
                  close
                </v-btn>
                <v-spacer />
                <v-btn
                  color="primary"
                  text
                  outlined
                  type="submit"
                  :loading="loading"
                  :disabled="fileName === '' || file_subject === ''"
                >
                  simpan file
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog> -->

        <v-dialog v-model="commentDialog" width="500" persistent>
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Catatan Approval
            </v-card-title>

            <v-card-text class="d-flex justify-center align-center">
              <v-col md="12" style="padding: 0; position: relative; top: 20px">
                <div style="padding: 0 10px">
                  <v-col cols="12" style="padding: 0">
                    <p
                      style="margin: 0; font-weight: bold"
                      v-if="commentNote != null"
                    >
                      {{ commentNote.note }}
                    </p>
                  </v-col>
                </div>
              </v-col>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-btn color="error" text outlined @click="closeCommentDialog">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <IncidentReportForm
          @loadPage="getDataFromApi"
          :dropdown="dropdown"
          :data="detailData"
        />
        <LeadingReportForm
          @loadPage="getDataFromApi"
          :dropdown="dropdown"
          :data="detailData"
        />
      </div>
      <v-card
        v-else
        flat
        height="90vh"
        style="display: flex; justify-content: center; align-items: center"
      >
        <v-toolbar-title class="overline">
          You Can't Access This Page</v-toolbar-title
        >
      </v-card>
    </div>
    <v-card
      v-else
      flat
      height="90vh"
      style="display: flex; justify-content: center; align-items: center"
    >
      <v-toolbar-title class="overline">
        You Can't Access This Page</v-toolbar-title
      >
    </v-card>
  </div>
  <div v-else>
    <v-card
      class="mx-auto"
      width="100%"
      style="
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        position: fixed;
        top: 0;
        height: 100%;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255);
      "
    >
      <v-progress-circular :size="170" :width="10" color="blue" indeterminate
        >Loading...</v-progress-circular
      >
    </v-card>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import buildType from '../../../../services/buildType'
const env = process.env.VUE_APP_BUILD_TYPE
export default {
  name: 'performancereportdetail',
  components: {
    IncidentReportForm: () => import('../incidentreport/components/Form.vue'),
    LeadingReportForm: () => import('../leadingreport/components/Form.vue')
  },
  data: () => ({
    config: require('../../../../services/config.json')[env],
    build: process.env.VUE_APP_BUILD_TYPE,
    oAuthApi: buildType.apiURL('oauth'),
    dssApi: buildType.apiURL('dss'),
    eSanqua: buildType.apiURL('esanqua'),
    uploadApi: buildType.apiURL('upload2'),
    hrsApi: buildType.apiURL('hrs'),
    isAllowApprove: false,
    permission: null,
    appLevel: null,
    userLevel: null,
    paramAPI: {
      page: 1,
      keyword: '',
      offset: 0,
      limit: 10,
      itemsPerPage: 10,
      sortBy: 'date',
      sortType: 'desc',
      company_id: null,
      audit_type_id: null,
      area: null,
      scope: null
    },
    detailData: null,
    leadingReportData: [],
    incidentReportData: [],
    form: null,
    isEdit: false,
    loading: false,
    isDisableCompanyDropdown: false,
    skeleton_loading: true,
    isLoadingPage: true,
    searchEmployee: null,
    rules: {
      nameRules: [],
      companyRules: [],
      auditTypeRules: [],
      clauseRules: [],
      docRules: [],
      subjectRules: [],
      employeeRules: [],
      memberTypeRules: [],
      memberScopeRules: [],
      memberAreaRules: []
    },
    dropdown: {
      company: [],
      auditType: [],
      department: [],
      area: [],
      scope: [],
      employee: [],
      body_part: [],
      memberType: [
        {
          id: 1,
          name: 'Member'
        },
        {
          id: 2,
          name: 'Leader'
        }
      ]
    },
    tab: null,
    commentDialog: false,
    commentNote: null
  }),

  async mounted() {
    // this.paramAPI.company_id = Number(
    //   this.getUserProfile.employee.company.plant_id
    // )
    // this.paramAPI.department_id = this.getUserProfile.employee.department_id

    this.appLevel = this.config.application.dss.userLevel
    this.appLevel.administrator =
      this.config.application.all.userLevel.administrator
    this.getDataMenu()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  computed: {
    // , 'getDropdownPlant', 'getShiftSettingPageQuery'
    ...mapGetters(['getUserProfile']),
    tabItems() {
      const arr = [
        { tab: 'Laporan Insiden', content: '' },
        { tab: 'Laporan Leading', content: '' },
        { tab: 'Approval', content: '' }
      ]
      return arr
    },
    incidentReportHeader() {
      let arrIncidentReportHeader = []
      if (this.detailData != null) {
        arrIncidentReportHeader = [
          {
            text: 'Status',
            value: 'status',
            align: 'left',
            sortable: false
          },
          {
            text: 'No. Dokumen',
            value: 'document_no',
            align: 'left',
            sortable: false
          },
          {
            text: 'Perusahaan',
            value: 'company_name',
            align: 'left',
            sortable: false
          },
          {
            text: 'Lokasi Insiden',
            value: 'incident_location_name',
            align: 'left',
            sortable: false
          },
          {
            text: 'Tgl. Insiden',
            value: 'incident_date',
            align: 'left',
            sortable: false
          },
          {
            text: 'Dilaporkan',
            value: 'reported_date',
            align: 'left',
            sortable: false
          },
          {
            text: 'Klasifikasi',
            value: 'classification',
            align: 'left',
            sortable: false
          },
          {
            text: 'Inspeksi',
            value: 'inspection_report',
            align: 'left',
            sortable: false
          },
          {
            text: 'Akar Masalah',
            value: 'root_problem_report',
            align: 'left',
            sortable: false
          }
        ]
      }
      return arrIncidentReportHeader
    },
    leadingReportHeader() {
      let arrLeadingReportHeader = []

      if (this.detailData != null) {
        arrLeadingReportHeader = [
          {
            text: 'Status',
            value: 'status',
            align: 'left',
            sortable: false
          },
          {
            text: 'No',
            value: 'document_no',
            align: 'left',
            sortable: false
          },
          {
            text: 'Perusahaan',
            value: 'company_name',
            align: 'left',
            sortable: false
          },
          {
            text: 'Kegiatan',
            value: 'leading',
            align: 'left',
            sortable: false
          },
          {
            text: 'Tgl. Kegiatan',
            value: 'leading_date',
            align: 'left',
            sortable: false
          },
          {
            text: 'Keterangan',
            value: 'description',
            align: 'left',
            sortable: false
          }
        ]
      }
      return arrLeadingReportHeader
    },
    approvalHeaders() {
      const arrHeaders = [
        { text: 'Seq', value: 'sequence', align: 'left' },
        { text: 'Doc. No', value: 'document_no', align: 'left' },
        { text: 'Model', value: 'table_name', align: 'center' },
        { text: 'User', value: 'approver_user', align: 'center' },
        {
          text: 'Min Acc',
          value: 'min_approver',
          align: 'center'
        },
        {
          text: 'Approved',
          value: 'approved',
          align: 'center'
        },
        {
          text: 'Rejected',
          value: 'rejected',
          align: 'center'
        },
        {
          text: 'CreatedAt',
          value: 'created_at',
          align: 'center'
        },
        {
          text: 'UpdateAt',
          value: 'updated_at',
          align: 'center'
        }
      ]
      return arrHeaders
    },
    frequencyRate() {
      let rate = 0
      if (this.detailData != null && this.detailData.summary != null) {
        rate =
          Math.round(
            ((this.detailData.summary.lti * 1000000) /
              this.detailData.manhour) *
              100
          ) / 100
      }

      return rate
    },
    severityRate() {
      let rate = 0
      if (this.detailData != null && this.detailData.summary != null) {
        rate =
          Math.round(
            ((this.detailData.summary.mandayLoss * 1000000) /
              this.detailData.manhour) *
              100
          ) / 100
      }
      return rate
    }
  },
  watch: {
    searchEmployee(val) {
      if (val !== '') {
        val && val !== this.detailData.pic && this.querySelectionEmployee(val)
      } else {
        this.detailData.pic = null
        this.dropdown.employee = []
      }
    }
  },
  methods: {
    ...mapActions(['menu_access', 'getMenuId']),
    ...mapMutations([
      // /*'setOvertimePageQuery'*/
    ]),
    actionSelect(event) {
      switch (event) {
        case 1:
          this.submitIncidentReport()
          break
        case 2:
          this.verifyItemScore()
          break
        case 3:
          this.setDraft()
          break
        case 4:
          this.cancelItemScore()
          break
      }
    },
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    showMsgDialog2(pModalType, pStatusMsg, pBtnCancel, pText) {
      let additional = ''
      if (pText !== undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              additional +
              '<br/>' +
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            confirmButtonText: 'Submit',
            cancelButtonText: 'No',
            input: 'textarea',
            inputLabel:
              'Tolong isi keterangan pada kolom dibawah sebelum submit',
            inputPlaceholder: 'Tulis disini...',
            inputAttributes: {
              'aria-label': 'Tulis disini'
            }
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    async initDropdown() {
      this.getDropdownCompany()
      this.getDropdownArea()
      this.getDropdownBodyPart()
    },
    async getDropdownCompany() {
      if (this.userLevel !== null) {
        // if (this.userLevel.is_admin !== null) {
        if (this.userLevel.user_user_level !== null) {
          if (
            this.userLevel.user_user_level.allowed_company === null ||
            this.userLevel.user_user_level.allowed_company.length === 0
          ) {
            this.dropdownCompanyApi()
          } else {
            this.dropdown.company =
              this.userLevel.user_user_level.allowed_company
            this.isDisableCompanyDropdown = false
          }
        } else {
          this.dropdownCompanyApi()
        }
        // }
      }
      // else {
      //   this.dropdownCompanyApi()
      // }
    },
    async dropdownCompanyApi() {
      if (Number(this.getUserProfile.employee.company.plant_id) !== 6) {
        this.isDisableCompanyDropdown = this.userLevel.is_support
      } else {
        this.isDisableCompanyDropdown = false
      }
      axios
        .get(`${this.eSanqua}master/universal/plant/dropdown`)
        .then((res) => {
          this.dropdown.company = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async getDataMenu() {
      this.isLoadingPage = true
      const split = this.$route.path.split('/')
      const routeModule = '/' + split[1] + '/' + split[2] + '/' + split[3]
      console.log('Path>>>>>', routeModule)
      await this.getMenuId({
        keyword: '',
        path: routeModule
      })
        .then((result) => {
          if (result.data.status_code === '00') {
            const menuId = result.data.data[0].id
            this.userLevel = this.getUserProfile.level.find(
              ({ application }) =>
                application.id === this.config.application.dss.applicationId ||
                application.id === this.config.application.all.applicationId
            )
            // console.log('userLevel>>>>>', this.userLevel)
            if (this.userLevel !== null) {
              if (
                this.getUserProfile.level.find(
                  ({ id }) => id == this.appLevel.administrator
                ) !== undefined
              ) {
                this.resetPermission({
                  data: {
                    read_perm: 1,
                    create_perm: 1,
                    update_perm: 1,
                    delete_perm: 1
                  }
                })
              } else {
                this.checkMenuAccess([menuId, this.userLevel.id])
              }
            } else {
              this.resetPermission(null)
            }
          } else {
            this.isLoadingPage = false
          }
        })
        .catch((err) => {
          console.log(err)
          this.isLoadingPage = false
        })
    },
    async checkMenuAccess(payload) {
      await this.menu_access(payload)
        .then((result) => {
          console.log('menuAccess>>>>', result)
          this.resetPermission(result)
        })
        .catch((err) => {
          console.log(err)
          this.resetPermission(null)
        })
    },
    resetPermission(val) {
      this.permission = null

      if (val !== null) {
        if (val.data !== null) {
          if (val.data.read_perm === 1) {
            this.permission = val.data
            this.initDataForLayout()
          }
        }
      }
      this.isLoadingPage = false
    },
    async initDataForLayout() {
      if (this.userLevel.is_support) {
        this.paramAPI.company_id = {
          id: 0,
          name: ''
        }
      } else {
        this.paramAPI.company_id = {
          id: Number(this.getUserProfile.employee.company.plant_id),
          name: this.getUserProfile.employee.company.name
        }
      }

      // if (
      //   this.getUserProfile.level.find(
      //     ({ id }) => id == this.appLevel.adminMaster
      //   ) !== undefined
      // ) {
      //   this.paramAPI.mode = ''
      // }
      // this.paramAPI.department_id = this.getUserProfile.employee.department_id

      // if (this.getOvertimePageQuery !== null) {
      //   this.paramAPI = this.getOvertimePageQuery
      // }
      setTimeout(async () => {
        this.initDropdown()
        await this.getDataFromApi()
      }, 200)
    },
    async getDataFromApi() {
      this.loading = true
      // this.panel = []
      // this.locationTab = null
      // this.locationTabItems = []
      const url = `${this.dssApi}performancereport/detail/${this.$route.params.id}`
      await axios
        .get(url)
        .then((res) => {
          console.log('Detaill >>>', res)
          if (res.data.status_code == '00') {
            this.loading = false
            let company = null
            let pic = null
            if (res.data.data.company_id != null) {
              company = {
                id: res.data.data.company_id,
                name: res.data.data.company_name
              }
              // delete res.data.data.company_id
              // delete res.data.data.company_name
            }
            if (res.data.data.pic_id != null) {
              pic = {
                id: res.data.data.pic_id,
                name: res.data.data.pic_name,
                nik: res.data.data.pic_nik
              }
              // delete res.data.data.pic_id
              // delete res.data.data.pic_name
              // delete res.data.data.pic_nik
            }
            res.data.data.report_date = res.data.data.report_date.slice(
              0,
              res.data.data.report_date.lastIndexOf('-')
            )
            this.detailData = res.data.data
            Object.assign(this.detailData, {
              company: company,
              pic: pic
            })

            if (res.data.data.status.id == 1) {
              this.authorityCheck(res.data.data)
            }
            setTimeout(() => {
              this.getIncidentReportData()
              this.getLeadingReportData()
            }, 300)
          } else {
            this.loading = false
            // this.showMsgDialog('error', res.data.status_msg, false)
          }
          return null
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
          return null
        })
    },
    authorityCheck(item) {
      if (item.approval_matrix !== null) {
        const matrixId = item.approval_matrix[0].document_id
        axios
          .get(
            `${this.oAuthApi}approval_matrix/document/allow_user?document_id=${matrixId}&application_id=23&table_name=tr_performancereports`
          )
          .then((res) => {
            console.log('AuthorityCheck>>>', res)

            if (res.data.status_code === '00') {
              if (res.data.is_allow_approve !== 0) {
                this.isAllowApprove = true
              } else {
                this.isAllowApprove = false
              }
            } else {
              this.isAllowApprove = false
            }
          })
          .catch((err) => {
            this.showMsgDialog(
              'error',
              err
                ? 'Cek Otoritas error, Silahkan info ke Admin'
                : 'Cek Otoritas error, Silahkan info ke Admin',
              false
            )
          })
      }
    },
    async fetchMatrix() {
      this.loading = true
      const form = {
        id: this.$route.params.id
        // approval_matrix_id: this.detailData.approval_matrix[0].document_id
      }
      await axios
        .post(`${this.dssApi}performancereport/fetch_matrix`, form)
        .then(async (res) => {
          if (res.data.status_code == '00') {
            if (res.data.approval_matrix_result.status_code == '00') {
              this.getDataFromApi()
            } else {
              this.showMsgDialog(
                'warning',
                res.data.approval_matrix_result.status_msg,
                false
              )
            }
          } else {
            this.showMsgDialog('error', res.data.status_msg, false)
          }
          this.loading = false
          this.showMsgDialog(
            res.data.status_code == '00' ? 'success' : 'warning',
            res.data.status_msg,
            false
          )
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
        })
    },
    enableEdit() {
      this.isEdit = !this.isEdit

      if (!this.isEdit) {
        this.dropdown.employee = []
        this.detailData.pic = null
        this.searchEmployee = null
        this.getDataFromApi()
      } else {
        this.querySelectionEmployee(this.detailData.pic_name)
      }
    },

    saveForm() {
      this.rules.nameRules = [(v) => !!v || 'Name is required']

      const self = this
      setTimeout(function () {
        if (self.$refs.entryForm.validate()) {
          const form = {
            act: 'update',
            id: self.detailData.id,
            name: self.detailData.name,
            // company_id: self.detailData.company.id,
            // company_name: self.detailData.company.name,
            report_date: self.detailData.report_date,
            total_employee: self.detailData.total_employee,
            total_other_people: self.detailData.total_other_people,
            workdays: self.detailData.workdays
          }
          if (self.detailData.company != null) {
            Object.assign(form, {
              company_id: self.detailData.company.id,
              company_name: self.detailData.company.name
            })
          }
          if (self.detailData.pic != null) {
            Object.assign(form, {
              pic_id: self.detailData.pic.id,
              pic_name: self.detailData.pic.name,
              pic_nik: self.detailData.pic.nik
            })
          }
          //  else {
          //   Object.assign(form, {
          //     pic_id: self.detailData.pic.id,
          //     pic_name: self.detailData.pic.name,
          //     pic_nik: self.detailData.pic.nik
          //   })
          // }
          console.log('form>>>', form)

          self.submitForm(form)
        }
      })
    },
    async submitForm(form) {
      console.log(form)
      await axios
        .post(`${this.dssApi}performancereport/save`, form)
        .then(async (res) => {
          console.log(res.data)
          if (res.data.status_code !== '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            this.enableEdit()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    closeDetailReport() {
      this.detailData = null
      this.isEdit = false
      setTimeout(() => {
        this.$router.push('/dss/k3/performancereport')
      }, 300)
    },
    submitReportDocument() {
      this.showMsgDialog(
        'question',
        'Anda yakin ingin submit dokumen ini ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.$route.params.id
          }
          axios
            .post(`${this.dssApi}performancereport/submit`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                // this.selectedData = []
                this.showMsgDialog('success', res.data.status_msg, false)
                // if (this.detailData.approval_matrix !== null) {
                //   await this.fetchMatrix()
                // } else {
                this.getDataFromApi()
                // }
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },
    confirmReportDocument() {
      this.showMsgDialog2('question', 'Confirm dokumen ini ?', true).then(
        async (res) => {
          if (res.isConfirmed) {
            this.loading = true
            const form = {
              document_id: this.$route.params.id,
              note: res.value
            }
            axios
              .post(`${this.dssApi}performancereport/approve`, form)
              .then(async (res) => {
                this.loading = false
                if (res.data.status_code == '00') {
                  this.showMsgDialog('success', res.data.status_msg, false)
                  this.getDataFromApi()
                  // if (this.detailData.approval_matrix !== null) {
                  //   await this.fetch()
                  //   console.log('fetch done')
                  // } else {
                  //   this.getDataFromApi()
                  // }
                } else {
                  this.showMsgDialog('warning', res.data.status_msg, false)
                }
              })
              .catch((err) => {
                this.showMsgDialog('error', err, false)
                this.loading = false
              })
          }
        }
      )
    },
    rejectReportDocument() {
      this.showMsgDialog2('question', 'Confirm dokumen ini ?', true).then(
        async (res) => {
          if (res.isConfirmed) {
            this.loading = true
            const form = {
              document_id: this.$route.params.id,
              note: res.value
            }
            axios
              .post(`${this.dssApi}performancereport/reject`, form)
              .then(async (res) => {
                this.loading = false
                if (res.data.status_code == '00') {
                  this.showMsgDialog('success', res.data.status_msg, false)
                  this.getDataFromApi()
                  // if (this.detailData.approval_matrix !== null) {
                  //   await this.fetch()
                  //   console.log('fetch done')
                  // } else {
                  //   this.getDataFromApi()
                  // }
                } else {
                  this.showMsgDialog('warning', res.data.status_msg, false)
                }
              })
              .catch((err) => {
                this.showMsgDialog('error', err, false)
                this.loading = false
              })
          }
        }
      )
    },
    doneReportDocument() {
      this.showMsgDialog(
        'question',
        'Update dokumen menjadi DONE ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.$route.params.id
            // note: res.value
          }
          axios
            .post(`${this.dssApi}performancereport/done`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                // this.selectedData = []
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
                // if (this.detailData.approval_matrix !== null) {
                //   await this.fetch()
                //   console.log('fetch done')
                // } else {
                //   this.getDataFromApi()
                // }
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },
    cancelReportDocument() {
      this.showMsgDialog2(
        'question',
        'Anda yakin ingin cancel dokumen ini ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.$route.params.id,
            note: res.value
          }
          axios
            .post(`${this.dssApi}performancereport/cancel`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                // this.selectedData = []
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
                // if (this.detailData.approval_matrix !== null) {
                //   await this.fetch()
                //   console.log('fetch done')
                // } else {
                //   this.getDataFromApi()
                // }
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },
    setDraftReport() {
      this.showMsgDialog(
        'question',
        'Anda yakin ingin SET DRAFT dokumen ini ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          const form = {
            id: this.$route.params.id
            // note: res.value
          }
          axios
            .post(`${this.dssApi}performancereport/set_to_draft`, form)
            .then(async (res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                // this.selectedData = []
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
                // if (this.detailData.approval_matrix !== null) {
                //   await this.fetch()
                //   console.log('fetch done')
                // } else {
                //   this.getDataFromApi()
                // }
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              this.showMsgDialog('error', err, false)
              this.loading = false
            })
        }
      })
    },
    async deleteIncidentReport() {
      // this.showMsgDialog(
      //   'question',
      //   `Delete ${this.selectedData.length} item yang dipilih ?`,
      //   true
      // ).then(async (res) => {
      //   let successCount = 0
      //   let failCount = 0
      //   if (res.isConfirmed) {
      //     this.loading = true
      //     for (let i = 0; i < this.selectedData.length; i++) {
      //       await axios
      //         .delete(
      //           `${this.dssApi}audit/item/delete/${this.selectedData[i].id}`
      //         )
      //         .then((res) => {
      //           if (res.data.status_code === '00') {
      //             successCount = successCount + 1
      //           } else {
      //             failCount = failCount + 1
      //           }
      //           return null
      //         })
      //         .catch((err) => {
      //           console.log(err)
      //           failCount = failCount + 1
      //           return null
      //         })
      //     }
      //     this.actionValue = 0
      //     const additionalHtml =
      //       '<span>' +
      //       'Finish' +
      //       '</span>' +
      //       '<br/>' +
      //       '<span>' +
      //       `Delete berhasil = ${successCount}` +
      //       '</span>' +
      //       '<br/>' +
      //       '<span>' +
      //       `Delete gagal = ${failCount}` +
      //       '</span>'
      //     this.showMsgDialog('success', additionalHtml, 'false')
      //     this.getDataFromApi()
      //     this.loading = false
      //   } else {
      //     this.actionValue = 0
      //   }
      // })
    },
    async deleteLeadingReport() {
      // this.showMsgDialog(
      //   'question',
      //   `Delete ${this.selectedData.length} item yang dipilih ?`,
      //   true
      // ).then(async (res) => {
      //   let successCount = 0
      //   let failCount = 0
      //   if (res.isConfirmed) {
      //     this.loading = true
      //     for (let i = 0; i < this.selectedData.length; i++) {
      //       await axios
      //         .delete(
      //           `${this.dssApi}audit/item/delete/${this.selectedData[i].id}`
      //         )
      //         .then((res) => {
      //           if (res.data.status_code === '00') {
      //             successCount = successCount + 1
      //           } else {
      //             failCount = failCount + 1
      //           }
      //           return null
      //         })
      //         .catch((err) => {
      //           console.log(err)
      //           failCount = failCount + 1
      //           return null
      //         })
      //     }
      //     this.actionValue = 0
      //     const additionalHtml =
      //       '<span>' +
      //       'Finish' +
      //       '</span>' +
      //       '<br/>' +
      //       '<span>' +
      //       `Delete berhasil = ${successCount}` +
      //       '</span>' +
      //       '<br/>' +
      //       '<span>' +
      //       `Delete gagal = ${failCount}` +
      //       '</span>'
      //     this.showMsgDialog('success', additionalHtml, 'false')
      //     this.getDataFromApi()
      //     this.loading = false
      //   } else {
      //     this.actionValue = 0
      //   }
      // })
    },
    incidentReportRowClick(obj) {
      console.log('incident row click', obj)
      setTimeout(() => {
        window.open(`/dss/k3/incidentreport/detail/${obj.id}`, '_blank')
      }, 100)
    },
    leadingReportRowClick(obj) {
      console.log('leading row click', obj)
    },
    getIncidentReportData() {
      const start_date = this.detailData.report_date + '-01'
      const year = parseInt(start_date.split('-')[0], 10)
      const month = parseInt(start_date.split('-')[1], 10)
      const end_date = new Date(year, month, 0).toISOString().split('T')[0]

      const url = `${this.dssApi}initialreport/list?company_id=${this.detailData.company.id}&start_date=${start_date}&end_date=${end_date}&limit=all&offset=0`
      axios
        .get(url)
        .then((res) => {
          console.log('Incident Report >>>', res)
          if (res.data.status_code == '00') {
            this.incidentReportData = res.data.data
          } else {
            this.incidentReportData = []
          }
        })
        .catch((err) => {
          console.log(err)
          this.incidentReportData = []
        })
    },
    getLeadingReportData() {
      const start_date = this.detailData.report_date + '-01'
      const year = parseInt(start_date.split('-')[0], 10)
      const month = parseInt(start_date.split('-')[1], 10)
      const end_date = new Date(year, month, 0).toISOString().split('T')[0]

      const url = `${this.dssApi}leadingreport/list?start_date=${start_date}&end_date=${end_date}&limit=all&offset=0`
      axios
        .get(url)
        .then((res) => {
          console.log('Leading Report >>>', res)
          if (res.data.status_code == '00') {
            this.leadingReportData = res.data.data
          } else {
            this.leadingReportData = []
          }
        })
        .catch((err) => {
          console.log(err)
          this.leadingReportData = []
        })
    },
    addNewIncidentReport() {
      setTimeout(() => {
        document.getElementById('incidentReportForm').click()
      }, 200)
    },
    addNewLeadingReport() {
      setTimeout(() => {
        document.getElementById('leadingReportForm').click()
      }, 200)
    },
    openCommentDialog(obj) {
      console.log(obj)
      this.commentNote = obj
      setTimeout(() => {
        this.commentDialog = true
      }, 100)
    },
    closeCommentDialog() {
      this.commentDialog = false
      setTimeout(() => {
        this.commentNote = null
      }, 100)
    },
    async querySelectionEmployee(v) {
      await axios
        .get(`${this.hrsApi}employee/dropdown?keyword=${v}`)
        .then((res) => {
          this.loading = false
          if (res.data.status_code === '00') {
            const resArr = []
            for (let i = 0; i < res.data.data.length; i++) {
              resArr.push({
                id: Number(res.data.data[i].id),
                nik: res.data.data[i].nik,
                name: res.data.data[i].name
                // company_id: res.data.data[i].company_id,
                // company_name: this.getCompanyAlias(res.data.data[i].company_id),
                // photo: res.data.data[i].photo
              })
            }
            return (this.dropdown.employee = resArr)
          }
          return (this.dropdown.employee = [])
        })
        .catch((err) => {
          this.dropdown.employee = []
          return console.log(err)
        })
    },
    getDropdownArea() {
      const url = `${this.dssApi}master/universal/area/dropdown?keyword=`
      axios
        .get(url)
        .then((res) => {
          if (res.data.status_code === '00') {
            this.dropdown.area = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getDropdownBodyPart() {
      const url = `${this.dssApi}master/universal/bodypart/dropdown?keyword=`
      axios
        .get(url)
        .then((res) => {
          if (res.data.status_code === '00') {
            this.dropdown.body_part = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    async updatePage(p) {
      this.paramAPI.page = p
      this.paramAPI.offset = p - 1
      await this.getDataFromApi()
    },
    async updateItemPerPage(p) {
      this.paramAPI.itemsPerPage = p
      this.paramAPI.limit = p
      this.paramAPI.offset = 0
      await this.getDataFromApi()
    },
    convertDate(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      } else {
        return '-'
      }
    },
    statusColor(val) {
      if (val) {
        if (val.id == -1) {
          return 'red'
        } else {
          const arrColour = ['grey', 'orange', 'green', 'red', 'red']
          return arrColour[val.id]
        }
      }
    },
    itemStatusColor(val) {
      if (val) {
        if (val.id == -1) {
          return 'red'
        } else {
          const arrColour = ['black', 'green', 'green', 'red', 'red']
          return arrColour[val.id]
        }
      }
    },
    itemStatusName(val) {
      if (val) {
        if (val.id == -1) {
          return '-'
        } else {
          const arrStatus = ['Draft', 'In Progress', 'Done', 'Cancel', 'Reject']
          return arrStatus[val.id]
        }
      }
    },
    itemStatusLeadingColor(val) {
      if (val) {
        if (val.id == -1) {
          return 'red'
        } else {
          const arrColour = ['black', 'green', 'red']
          return arrColour[val.id]
        }
      }
    },
    itemStatusLeadingName(val) {
      if (val) {
        if (val.id == -1) {
          return '-'
        } else {
          const arrStatus = ['Draft', 'Submited', 'Cancel']
          return arrStatus[val.id]
        }
      }
    },
    getCompanyAlias(id) {
      switch (id) {
        case 1:
          return 'TMP'
        case 2:
          return 'IMP'
        case 3:
          return 'GIT'
        case 4:
          return 'KAJ'
        case 5:
          return 'WIM'
        case 6:
          return 'SMI'
        case 7:
          return 'THP'
        case 8:
          return 'GAI'
        case 9:
          return 'GPP'
        case 10:
          return 'BWN'
        case 11:
          return 'INO'
        case 12:
          return 'BPS'
        case 13:
          return 'BPC'
        case 14:
          return 'WIMS'
        case 15:
          return 'BWI'
        case 16:
          return 'DAM'
        case 17:
          return 'PSR'
        case 18:
          return 'GAP'
        case 19:
          return 'SKH'
        case 20:
          return 'PTI'
        case 21:
          return 'BMS'
        case 22:
          return 'SDA'
      }
    },
    watcherEmployee(val) {
      if (val != null) {
        console.log(val)
      } else {
      }
    },
    setSparator(val) {
      if (val != undefined) {
        if (val != null) {
          return val.toString().replace(/\B(?<!\\d*)(?=(\d{3})+(?!\d))/g, '.')
        }
      }
      return '0'
    },
    getRateColor() {
      if (this.detailData != null && this.detailData.summary != null) {
        if (this.detailData.summary.lti > 0) {
          return 'red'
        } else if (this.detailData.summary.mtc > 0) {
          return 'yellow'
        } else if (this.detailData.summary.fac > 0) {
          return 'orange'
        } else if (this.detailData.summary.emergency > 0) {
          return 'blue'
        } else {
          return '#F5F5F5'
        }
      }
      return '#F5F5F5'
    }
  }
}
</script>
<style lang="scss">
.actionButton {
  position: relative;
  display: flex;
  // width: 400px;
}
#formTemplateList {
  position: relative;
  .form-template-list-div {
    padding: 15px;
    min-height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .group-list-toolbar-1 {
      .group-list-toolbar-1 {
        width: 60%;
        display: flex;
        flex-direction: row;
        margin-left: auto;
      }
    }
    .form-template-list-toolbar2 {
      display: none;
    }
  }
}
.result-5r {
  padding: 5px;
  table {
    border-collapse: collapse;
    width: 100%;
    text-align: center;
  }

  thead {
    background-color: #f7f7f7;
  }

  th,
  td {
    padding: 6px 12px;
  }

  td:first-child {
    font-weight: bold;
    text-align: left;
  }
}
@media (max-width: 768px) {
  #formTemplateList {
    .form-template-list-div {
      .group-list-toolbar-1 {
        .group-list-toolbar-1 {
          display: none;
        }
      }
      .form-template-list-toolbar2 {
        display: block;
      }
    }
  }
}
</style>
